import { c as _c } from "react/compiler-runtime";
import { AnalyticsActions, AnalyticsCategories, AnalyticsEventType, AnalyticsLabels } from "@/constants/analytics";
import Image from "next/image";
import { type Dispatch, type SetStateAction } from "react";
import { sendGTMEvent } from "@/components/Tracking/TagManagerWrapper";
import { useTranslation } from "@/app/i18n/client";
import { DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { getLocalizedRoute } from "@/utils/localized-route";
import { useLocaleContext } from "@/app/i18n/client";
export function GDPRInfoPanel(t0) {
  const $ = _c(9);
  const {
    setShowSettingsPanel,
    rejectAll,
    acceptAll
  } = t0;
  let t1;
  if ($[0] !== rejectAll) {
    t1 = <div className="flex flex-wrap justify-center"><GDPRCookiesInfoPanel rejectAllFn={rejectAll} /></div>;
    $[0] = rejectAll;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== acceptAll || $[3] !== rejectAll || $[4] !== setShowSettingsPanel) {
    t2 = <GDPRInfoFooter setShowSettingsPanel={setShowSettingsPanel} rejectAll={rejectAll} acceptAll={acceptAll} />;
    $[2] = acceptAll;
    $[3] = rejectAll;
    $[4] = setShowSettingsPanel;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function GDPRCookiesInfoPanel(t0) {
  const $ = _c(42);
  const {
    rejectAllFn
  } = t0;
  const {
    t
  } = useTranslation();
  const lng = useLocaleContext();
  let t1;
  if ($[0] !== rejectAllFn) {
    t1 = function onClickDeclineAllCookies() {
      rejectAllFn();
      sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesInfo, AnalyticsLabels.button, AnalyticsActions.declineAllGdprCookiesClick);
    };
    $[0] = rejectAllFn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClickDeclineAllCookies = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("GDPRSETTINGS.IMGALT.COOKIE");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="hidden max-w-24 flex-1 md:block"><Image width={50} height={50} src="data:image/svg+xml;base64,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" alt={t2} loading="lazy" /></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("GDPRSETTINGS.DESCRIPTIONS.INFOPANEL.FIRST");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("GDPRSETTINGS.DESCRIPTIONS.INFOPANEL.REJECT");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClickDeclineAllCookies || $[11] !== t5) {
    t6 = <Button onClick={onClickDeclineAllCookies} variant="inline-link" size="inline">{t5}</Button>;
    $[10] = onClickDeclineAllCookies;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("GDPRSETTINGS.DESCRIPTIONS.INFOPANEL.SECOND");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <>{t4} {t6} {t7}</>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== lng) {
    t9 = getLocalizedRoute(lng, "imprint");
    $[19] = lng;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("NAV.IMPRINT.TEXT");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <Link href={t9} className="button-link text-matchbus">{t10}</Link>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== lng) {
    t12 = getLocalizedRoute(lng, "privacypolicy");
    $[26] = lng;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("NAV.DATA.TEXT");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <Link href={t12} className="button-link text-matchbus">{t13}</Link>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t14) {
    t15 = <div className="gdpr-privacy-links">{t11}{" "}|{" "}{t14}</div>;
    $[33] = t11;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t8) {
    t16 = <div className="[flex:3]">{t8}{t15}</div>;
    $[36] = t15;
    $[37] = t8;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16 || $[40] !== t3) {
    t17 = <>{t3}{t16}</>;
    $[39] = t16;
    $[40] = t3;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}
function GDPRInfoFooter(t0) {
  const $ = _c(21);
  const {
    setShowSettingsPanel,
    rejectAll,
    acceptAll
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== setShowSettingsPanel) {
    t1 = function onClickSettings() {
      setShowSettingsPanel(true);
      sendGTMEvent(AnalyticsEventType.Event, AnalyticsCategories.gdprCookiesInfo, AnalyticsLabels.button, AnalyticsActions.openGdprCookiesSettingsClick);
    };
    $[0] = setShowSettingsPanel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClickSettings = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("GDPRSETTINGS.BUTTONS.SETTINGS");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClickSettings || $[5] !== t2) {
    t3 = <Button onClick={onClickSettings} variant="cancel">{t2}</Button>;
    $[4] = onClickSettings;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("GDPRSETTINGS.BUTTONS.AGREETONEEDED");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rejectAll || $[10] !== t4) {
    t5 = <DialogClose asChild={true}><Button onClick={rejectAll} variant="submit">{t4}</Button></DialogClose>;
    $[9] = rejectAll;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("GDPRSETTINGS.BUTTONS.AGREETOALL");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== acceptAll || $[15] !== t6) {
    t7 = <DialogClose asChild={true}><Button onClick={acceptAll} variant="submit">{t6}</Button></DialogClose>;
    $[14] = acceptAll;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t7) {
    t8 = <div className="flex flex-row flex-wrap justify-end gap-2 overflow-hidden">{t3}{t5}{t7}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}